// Prolancer / برولانسر brand logo — green flying bird (uses official brand image)
export function LogoMark({ size = 44, className = "" }) {
  return (
    <img
      src="/prolancer-bird.png"
      alt="Prolancer bird"
      width={size}
      height={(size * 82) / 100}
      className={`inline-block object-contain ${className}`}
      style={{ width: size, height: "auto" }}
      draggable={false}
    />
  );
}

export function LogoLockup({ lang = "ar", theme = "dark", size = "md" }) {
  const dark = theme === "dark";
  const markSize = size === "lg" ? 56 : 44;
  return (
    <div className="flex items-center gap-2.5 shrink-0">
      <LogoMark size={markSize} className="shrink-0" />
      <div className={`flex flex-col leading-none shrink-0 ${lang === "ar" ? "font-arabic" : "font-outfit"}`}>
        <span className={`font-extrabold text-xl sm:text-2xl tracking-tight whitespace-nowrap ${dark ? "text-white" : "text-[#2d2c35]"}`}>
          {lang === "ar" ? "برولانسر" : "Prolancer"}
        </span>
        <div className="mt-1 flex items-center gap-2 whitespace-nowrap">
          <span className="inline-block h-[3px] w-6 sm:w-8 rounded-full bg-[#18c98f] shrink-0" />
          <span className={`text-[9px] sm:text-[10px] font-semibold tracking-[0.3em] whitespace-nowrap ${dark ? "text-[#b4b4be]" : "text-[#2d2c35]/60"}`}>
            PROLANCER
          </span>
        </div>
      </div>
    </div>
  );
}
